import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Re-seeds the edited params from the applied params after every apply.
 *
 * The modal auto-applies on every filter change, and applying clears the
 * edited draft. Without re-seeding, the next change would start from an empty
 * draft and replace the whole applied filter set — so the space-dimension
 * filter and the department filter would overwrite each other. Mirroring the
 * applied params back into the draft lets the two filters accumulate.
 */
export const reseedEditedParamsOnApply = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.currentListPlugin.feature.actions.applyParams.success
      .observe()
      .pipe(
        rxjs.map(action =>
          collection.plugins.currentListPlugin.feature.actions.startEditingParams
            .from(action)
            .create(),
        ),
      ),
)
